import { render, staticRenderFns } from "./StockTransferBulk.vue?vue&type=template&id=772d3666&"
import script from "./StockTransferBulk.vue?vue&type=script&lang=js&"
export * from "./StockTransferBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports